var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQaImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 596.466,
    height: 635.06,
    viewBox: "0 0 596.466 635.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ee0a6b;}.b{fill:#f2f2f2;}.c{fill:#3f3d56;}.d{fill:#ccc;}.e{fill:#e6e6e6;}.f{fill:#fff;}.g{opacity:0.1;}.h{fill:#2f2e41;}.i{fill:#57b894;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-182.766 -3909.938)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(182.766 3909.938)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.229 55.246)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.977,
    cy: 14.977,
    r: 14.977,
    transform: "translate(92.307 163.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M490.991,376.559c8.379-2.516,17.287-5.14,23.932-11.123,5.938-5.346,9.947-13.509,7.487-21.526-2.455-8-9.808-13.335-17.4-15.988a71.388,71.388,0,0,0-13.314-3c-4.9-.713-9.812-1.3-14.727-1.859q-29.85-3.414-59.924-4.171c-9.893-.249-19.784-.243-29.679-.1-8.836.128-18.143.125-26.34-3.631-6.375-2.921-12.16-8.234-13.937-15.216-2.05-8.06,1.731-16.268,7.157-22.105A57.944,57.944,0,0,1,363.9,269.8c3.74-2.583,7.611-4.984,11.565-7.224A161.057,161.057,0,0,1,399.8,251.349c4.15-1.509,8.362-2.811,12.61-4.012a107.885,107.885,0,0,0,10.652-3.411c6.7-2.671,13.076-7.2,14.78-14.613,1.615-7.03-1.108-14.662-5.882-19.884-5.523-6.042-13.851-8.691-21.835-9.119-8.963-.481-17.72,1.762-26.144,4.609-8.985,3.036-17.777,6.528-26.952,8.988a181.341,181.341,0,0,1-27.739,5.156,75.245,75.245,0,0,1-13.921.666c-3.866-.313-7.711-1.45-10.56-4.194a10.444,10.444,0,0,1-3.4-9c.091-.62,1.032-.356.942.26-.609,4.153,2.214,7.98,5.693,9.94,4.021,2.266,8.913,2.269,13.389,2.01a175.115,175.115,0,0,0,28.82-4.166,231.606,231.606,0,0,0,27.254-8.413c8.516-3.084,17.223-6.094,26.321-6.762,7.894-.58,16.2.57,23.076,4.7a25.528,25.528,0,0,1,11.905,16.611,19.254,19.254,0,0,1-5.665,18.337c-5.314,4.9-12.6,6.993-19.391,8.923a177.644,177.644,0,0,0-25.2,9.02,158.183,158.183,0,0,0-23.7,13.326c-7.243,4.95-14.392,11.178-16.683,20.008a18.432,18.432,0,0,0,.915,12.361,22.589,22.589,0,0,0,7.248,8.6c7.268,5.348,16.427,6.446,25.206,6.555,9.859.123,19.719-.21,29.582-.048q30.15.495,60.176,3.67,7.524.8,15.029,1.761a135.909,135.909,0,0,1,13.44,2.18c7.867,1.826,15.522,5.337,20.412,12.007a18.987,18.987,0,0,1,1.617,20.762c-3.755,7.388-10.788,12.087-18.257,15.174a129.523,129.523,0,0,1-12.292,4.15.489.489,0,0,1-.26-.942Z",
    transform: "translate(-294.231 -183.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(0 14.815)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(54.212 29.629)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(100.121)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(128.773 33.211)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(90.027 71.631)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(40.862 90.19)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(92.958 119.168)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(148.96 135.448)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.814,
    cy: 7.814,
    r: 7.814,
    transform: "translate(214.405 131.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M515.248,220.371a43.342,43.342,0,0,0-42.906,42.593c0,.216,0,1.736,0,3.723a10.988,10.988,0,0,0,10.986,10.988h0a10.994,10.994,0,0,0,10.992-11c0-1.354,0-2.29,0-2.348a20.838,20.838,0,1,1,32.078,17.543l0,0s-15.638,10.067-20.406,23.878h0a30.606,30.606,0,0,0-1.261,8.716c0,1.213.071,11.826.209,20.44a11.326,11.326,0,0,0,11.328,11.143h0a11.329,11.329,0,0,0,11.329-11.4c-.048-7.889-.074-17.075-.074-17.742,0-8.48,8.181-16.929,14.9-22.439a45.193,45.193,0,0,0,15.543-24.745,28.247,28.247,0,0,0,.814-6.132,43.223,43.223,0,0,0-43.535-43.222Z",
    transform: "translate(-409.568 -198.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M486.108,309.536h0a10.988,10.988,0,0,1-10.987-10.986c0-1.989,0-3.508,0-3.724a42.818,42.818,0,0,1,5-19.506,42.915,42.915,0,0,0-8.257,24.716c0,.216,0,1.736,0,3.723a10.988,10.988,0,0,0,10.986,10.988h0a11,11,0,0,0,10.578-8.007A10.948,10.948,0,0,1,486.108,309.536Z",
    transform: "translate(-409.25 -235.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M571.5,280.638a20.839,20.839,0,0,1,18.122,29.113,20.837,20.837,0,1,0-34.978-21.81A20.8,20.8,0,0,1,571.5,280.638Z",
    transform: "translate(-465.079 -235.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M586.157,498.371h0a11.327,11.327,0,0,1-11.328-11.145c-.138-8.611-.209-19.225-.209-20.438a30.606,30.606,0,0,1,1.261-8.715h0a30.932,30.932,0,0,1,1.789-4.135,35.829,35.829,0,0,0-5.045,9.345h0A30.606,30.606,0,0,0,571.365,472c0,1.213.071,11.826.209,20.44A11.327,11.327,0,0,0,582.9,503.581h0a11.331,11.331,0,0,0,10.875-8.154A11.286,11.286,0,0,1,586.157,498.371Z",
    transform: "translate(-476.353 -355.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M574.678,686.937a14.976,14.976,0,0,1-5.558-23.276,14.976,14.976,0,1,0,20.372,21.64,14.967,14.967,0,0,1-14.814,1.636Z",
    transform: "translate(-470.694 -497.186)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M595.489,368.268H544.977a7.1,7.1,0,0,1-7.1-7.1V285.265a7.1,7.1,0,0,1,7.1-7.1h50.512a7.1,7.1,0,0,1,7.1,7.1v75.907A7.1,7.1,0,0,1,595.489,368.268ZM544.977,279a6.269,6.269,0,0,0-6.262,6.262v75.907a6.269,6.269,0,0,0,6.262,6.262h50.512a6.269,6.269,0,0,0,6.262-6.262V285.265A6.269,6.269,0,0,0,595.489,279Z",
    transform: "translate(-537.88 -83.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M603.495,332.379H568.428a3.552,3.552,0,0,1-3.548-3.548v-16.7a3.552,3.552,0,0,1,3.548-3.548h35.066a3.553,3.553,0,0,1,3.548,3.548v16.7A3.552,3.552,0,0,1,603.495,332.379Z",
    transform: "translate(-553.609 -100.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M604.776,393.763H574.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,1,1,0,6.679Z",
    transform: "translate(-557.395 -146.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M604.776,423.763H574.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,0,1,0,6.679Z",
    transform: "translate(-557.395 -164.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M604.776,453.763H574.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,1,1,0,6.679Z",
    transform: "translate(-557.395 -181.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M890.489,470.268H839.977a7.1,7.1,0,0,1-7.1-7.1V387.265a7.1,7.1,0,0,1,7.1-7.1h50.512a7.1,7.1,0,0,1,7.1,7.1v75.907A7.1,7.1,0,0,1,890.489,470.268ZM839.977,381a6.269,6.269,0,0,0-6.262,6.262v75.907a6.269,6.269,0,0,0,6.262,6.262h50.512a6.269,6.269,0,0,0,6.262-6.262V387.265A6.269,6.269,0,0,0,890.489,381Z",
    transform: "translate(-604.114 -291.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M899.777,415.763H869.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,1,1,0,6.679Z",
    transform: "translate(-623.629 -308.442)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M899.777,445.763H869.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,1,1,0,6.679Z",
    transform: "translate(-623.629 -325.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M898.495,498.379H863.428a3.553,3.553,0,0,1-3.548-3.548v-16.7a3.553,3.553,0,0,1,3.548-3.548h35.066a3.553,3.553,0,0,1,3.548,3.548v16.7A3.553,3.553,0,0,1,898.495,498.379Z",
    transform: "translate(-619.843 -346.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M899.777,557.763H869.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,1,1,0,6.679Z",
    transform: "translate(-623.629 -391.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M816.489,221.464H765.977a7.1,7.1,0,0,1-7.1-7.1v-47.1a7.1,7.1,0,0,1,7.1-7.1h50.512a7.1,7.1,0,0,1,7.1,7.1v47.1a7.1,7.1,0,0,1-7.1,7.1ZM765.977,161a6.269,6.269,0,0,0-6.262,6.262v47.1a6.269,6.269,0,0,0,6.262,6.262h50.512a6.269,6.269,0,0,0,6.262-6.262v-47.1A6.269,6.269,0,0,0,816.489,161Z",
    transform: "translate(-579.791 -151.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M825.777,262.263H795.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,0,1,0,6.679Z",
    transform: "translate(-599.306 -207.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M825.777,232.263H795.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,0,1,0,6.679Z",
    transform: "translate(-599.306 -189.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M825.777,202.263H795.72a3.34,3.34,0,1,1,0-6.679h30.057a3.34,3.34,0,0,1,0,6.679Z",
    transform: "translate(-599.306 -172.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9.601,
    cy: 9.601,
    r: 9.601,
    transform: "translate(50.93 187.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M676.052,281.584a1,1,0,0,1-.6-.2l-.011-.008-2.256-1.728a1,1,0,0,1,1.219-1.591l1.462,1.121,3.454-4.5a1,1,0,0,1,1.406-.186l-.022.029.022-.029a1,1,0,0,1,.185,1.405l-4.062,5.3A1,1,0,0,1,676.052,281.584Z",
    transform: "translate(-616.473 -80.882)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 9.601,
    cy: 9.601,
    r: 9.601,
    transform: "translate(281.783 81.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M976.052,384.584a1,1,0,0,1-.6-.2l-.011-.008-2.256-1.728a1,1,0,1,1,1.219-1.591l1.461,1.121,3.454-4.5a1,1,0,0,1,1.406-.186l-.021.029.022-.029a1,1,0,0,1,.186,1.405l-4.062,5.3a1,1,0,0,1-.8.391Z",
    transform: "translate(-685.619 -289.916)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 9.601,
    cy: 9.601,
    r: 9.601,
    transform: "translate(232.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M903.052,161.584a1,1,0,0,1-.6-.2l-.011-.008-2.256-1.728a1,1,0,0,1,1.219-1.592l1.462,1.121,3.454-4.5a1,1,0,0,1,1.406-.186l-.021.029.022-.029a1,1,0,0,1,.186,1.406l-4.062,5.3A1,1,0,0,1,903.052,161.584Z",
    transform: "translate(-661.879 -148.32)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(370.032 4156.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M213.524,146.387a1.777,1.777,0,0,1,1.775,1.775v38.468a1.777,1.777,0,0,1-1.775,1.775H175.841a1.777,1.777,0,0,1-1.775-1.775V148.162a1.777,1.777,0,0,1,1.775-1.775h37.682m0-1.775H175.841a3.55,3.55,0,0,0-3.55,3.55v38.468a3.55,3.55,0,0,0,3.55,3.55h37.682a3.55,3.55,0,0,0,3.55-3.55V148.162A3.55,3.55,0,0,0,213.524,144.612Z",
    transform: "translate(-172.291 -144.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M215.064,164.541H189.922a.888.888,0,0,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-179.708 -152.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M215.064,175.826H189.922a.888.888,0,0,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-179.708 -157.653)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M215.064,187.109H189.922a.888.888,0,1,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-179.708 -162.652)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M215.064,198.394H189.922a.888.888,0,1,1,0-1.775h25.141a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-179.708 -167.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M215.064,209.679H189.922a.888.888,0,0,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-179.708 -172.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M444.585,146.387a1.777,1.777,0,0,1,1.775,1.775v38.468a1.777,1.777,0,0,1-1.775,1.775H406.9a1.777,1.777,0,0,1-1.775-1.775V148.162a1.777,1.777,0,0,1,1.775-1.775h37.682m0-1.775H406.9a3.55,3.55,0,0,0-3.55,3.55v38.468a3.55,3.55,0,0,0,3.55,3.55h37.682a3.55,3.55,0,0,0,3.55-3.55V148.162a3.55,3.55,0,0,0-3.55-3.55Z",
    transform: "translate(-274.65 -144.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M446.125,164.541H420.983a.888.888,0,1,1,0-1.775h25.141a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-282.067 -152.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M446.125,175.826H420.983a.888.888,0,1,1,0-1.775h25.141a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-282.067 -157.653)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M446.125,187.109H420.983a.888.888,0,1,1,0-1.775h25.141a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-282.067 -162.652)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M446.125,198.394H420.983a.888.888,0,1,1,0-1.775h25.141a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-282.067 -167.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M446.125,209.679H420.983a.888.888,0,1,1,0-1.775h25.141a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-282.067 -172.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M674.524,279.179a1.777,1.777,0,0,1,1.775,1.775v38.468a1.777,1.777,0,0,1-1.775,1.775H636.841a1.777,1.777,0,0,1-1.775-1.775V280.954a1.777,1.777,0,0,1,1.775-1.775h37.682m0-1.775H636.841a3.55,3.55,0,0,0-3.55,3.55v38.468a3.55,3.55,0,0,0,3.55,3.55h37.682a3.55,3.55,0,0,0,3.55-3.55V280.954A3.55,3.55,0,0,0,674.524,277.4Z",
    transform: "translate(-376.512 -203.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M676.064,297.332H650.922a.888.888,0,0,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-383.929 -211.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M676.064,308.617H650.922a.888.888,0,1,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-383.929 -216.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M676.064,319.9H650.922a.888.888,0,0,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-383.929 -221.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M676.064,331.185H650.922a.888.888,0,0,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-383.929 -226.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M676.064,342.47H650.922a.888.888,0,0,1,0-1.775h25.141a.888.888,0,0,1,0,1.775Z",
    transform: "translate(-383.929 -231.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M328.841,198.142H290.172a3.949,3.949,0,0,1-3.944-3.944v-27.67a3.949,3.949,0,0,1,3.944-3.945h38.669a3.949,3.949,0,0,1,3.945,3.945V194.2A3.949,3.949,0,0,1,328.841,198.142Zm-38.669-33.784a2.172,2.172,0,0,0-2.169,2.17V194.2a2.171,2.171,0,0,0,2.169,2.169h38.669a2.172,2.172,0,0,0,2.17-2.169v-27.67a2.172,2.172,0,0,0-2.17-2.17Z",
    transform: "translate(-222.764 -152.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M329.889,183.4H304.747a.888.888,0,1,1,0-1.775h25.142a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-230.575 -161.009)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M329.889,194.685H304.747a.888.888,0,1,1,0-1.775h25.142a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-230.575 -166.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M329.889,205.969H304.747a.888.888,0,1,1,0-1.775h25.142a.888.888,0,1,1,0,1.775Z",
    transform: "translate(-230.575 -171.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M561.291,218.1l-37.139-10.77a3.949,3.949,0,0,1-2.69-4.887l7.707-26.575a3.949,3.949,0,0,1,4.887-2.69l37.139,10.77a3.949,3.949,0,0,1,2.69,4.887l-7.707,26.575a3.949,3.949,0,0,1-4.887,2.689Zm-27.729-43.217a2.172,2.172,0,0,0-2.688,1.48l-7.707,26.575a2.172,2.172,0,0,0,1.479,2.688l37.139,10.77a2.172,2.172,0,0,0,2.688-1.479l7.707-26.575a2.172,2.172,0,0,0-1.479-2.688Z",
    transform: "translate(-326.903 -157.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M573.3,203.651l-24.147-7a.888.888,0,1,1,.494-1.7l24.147,7a.888.888,0,0,1-.494,1.7Z",
    transform: "translate(-338.957 -166.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M570.161,214.489l-24.147-7a.888.888,0,0,1,.494-1.7l24.147,7a.888.888,0,0,1-.494,1.7Z",
    transform: "translate(-337.565 -171.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M567.018,225.327l-24.146-7a.888.888,0,0,1,.494-1.7l24.147,7a.888.888,0,0,1-.494,1.7Z",
    transform: "translate(-336.173 -176.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M511.763,580.886H448.421l2.147-27.913h59.047Z",
    transform: "translate(-198.648 -244.964)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 70.857,
    height: 6.442,
    transform: "translate(246.552 332.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M697.706,374.74H455.612a6.442,6.442,0,0,0-6.442,6.442h0V528.8H704.147V381.182a6.441,6.441,0,0,0-6.442-6.442Z",
    transform: "translate(-294.947 -246.558)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M449.171,651.326v24.156a6.441,6.441,0,0,0,6.442,6.441H697.706a6.441,6.441,0,0,0,6.441-6.441h0V651.326Z",
    transform: "translate(-294.948 -369.084)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 229.748,
    height: 128.831,
    transform: "translate(167.106 141.603)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 6.442,
    cy: 6.442,
    r: 6.442,
    transform: "translate(275.539 290.831)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 1.222,
    cy: 1.222,
    r: 1.222,
    transform: "translate(173.048 144.599)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 1.222,
    cy: 1.222,
    r: 1.222,
    transform: "translate(177.687 144.599)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 1.222,
    cy: 1.222,
    r: 1.222,
    transform: "translate(182.328 144.599)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 217.185,
    height: 108.196,
    transform: "translate(173.047 149.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M508.274,443.411a.768.768,0,0,0-.768.768v38.81a.768.768,0,0,0,.768.768h44.819a.768.768,0,0,0,.768-.768V444.179a.768.768,0,0,0-.768-.768Z",
    transform: "translate(-320.79 -276.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M637.47,443.635a.768.768,0,0,0-.768.768v38.685a.768.768,0,0,0,.768.768h44.676a.768.768,0,0,0,.768-.768V444.4a.768.768,0,0,0-.767-.768Z",
    transform: "translate(-378.023 -277.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M765.312,442.907a.769.769,0,0,0-.768.768v39.09a.769.769,0,0,0,.767.768h45.141a.769.769,0,0,0,.768-.768v-39.09a.768.768,0,0,0-.767-.768Z",
    transform: "translate(-434.656 -276.755)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M509.094,550.333a1.587,1.587,0,0,0,0,3.175h42.139a1.587,1.587,0,0,0,0-3.175Z",
    transform: "translate(-320.79 -324.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M509.093,563.889a1.588,1.588,0,0,0,0,3.175h18.973a1.588,1.588,0,0,0,0-3.175Z",
    transform: "translate(-320.79 -330.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M639.678,550.333a1.587,1.587,0,0,0,0,3.175h42.139a1.587,1.587,0,0,0,0-3.175Z",
    transform: "translate(-378.638 -324.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M639.677,563.889a1.588,1.588,0,0,0,0,3.175h18.973a1.588,1.588,0,0,0,0-3.175Z",
    transform: "translate(-378.638 -330.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M767,550.333a1.587,1.587,0,0,0,0,3.175h42.139a1.587,1.587,0,1,0,0-3.175Z",
    transform: "translate(-435.04 -324.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M509.094,536.333a1.587,1.587,0,0,0,0,3.175h42.139a1.587,1.587,0,0,0,0-3.175Z",
    transform: "translate(-320.79 -318.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M639.678,536.333a1.587,1.587,0,0,0,0,3.175h42.139a1.587,1.587,0,0,0,0-3.175Z",
    transform: "translate(-378.638 -318.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M767,536.333a1.587,1.587,0,0,0,0,3.175h42.139a1.587,1.587,0,1,0,0-3.175Z",
    transform: "translate(-435.04 -318.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M767,563.889a1.588,1.588,0,0,0,0,3.175H785.97a1.588,1.588,0,1,0,0-3.175Z",
    transform: "translate(-435.04 -330.35)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(295.604 4255.92)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M413.443,233.581v121.01l-40.337,33.322H166.746V261.057l60.213-27.476Z",
    transform: "translate(-166.746 -142.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M413.443,233.581v.485l-14.48,9.693-25.856,17.3H166.746l60.213-27.476Z",
    transform: "translate(-166.746 -142.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M718.18,233.581v121.01l-40.337,33.322.292-127.148L703.7,243.759l14.247-10.178Z",
    transform: "translate(-471.483 -142.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M457.49,267.075H331.8l9.354-5.261H461.582Z",
    transform: "translate(-265.16 -159.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M692.123,331.868s.182,2.006.547,2.188,3.1,4.741,0,5.653-4.923.547-5.653.912-13.493,1.094-13.676-.912,6.2-2.37,6.2-2.37,5.835-3.829,6.747-5.835S692.123,331.868,692.123,331.868Z",
    transform: "translate(-526.369 -243.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M436.422,113.955,385.974,8.828,301.62,49.308l31.023,64.648Z",
    transform: "translate(-247.163 -8.828)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 49.695,
    height: 3.085,
    transform: "translate(76.936 62.766) rotate(-25.635)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 49.695,
    height: 3.085,
    transform: "translate(88.798 87.486) rotate(-25.635)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 12.338,
    height: 12.338,
    transform: "translate(130.627 32.059) rotate(-25.635)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 12.338,
    height: 12.338,
    transform: "translate(142.489 56.779) rotate(-25.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M502.586,55.924,498,68.958l-6.175-2.171-.845,2.4,8.572,3.012,5.434-15.435Z",
    transform: "translate(-360.07 -36.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M531.965,117.146l-4.581,13.034-6.175-2.17-.845,2.4,8.571,3.012,5.434-15.435Z",
    transform: "translate(-377.587 -73.412)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(344.848 4395.049)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 1.141,
    height: 0.95,
    transform: "translate(2.186 52.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M318.956,483.653h-2.247v-.95h2.247Zm-4.495,0h-2.248v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.247Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95H283Zm-4.495,0h-2.248v-.95H278.5Zm-4.5,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0H235.8v-.95h2.247Zm-4.495,0H231.3v-.95h2.247Zm-4.495,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Z",
    transform: "translate(-207.75 -430.192)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 1.141,
    height: 0.95,
    transform: "translate(2.186 27.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M318.956,356.653h-2.247v-.95h2.247Zm-4.495,0h-2.248v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.247Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95H283Zm-4.495,0h-2.248v-.95H278.5Zm-4.5,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0H235.8v-.95h2.247Zm-4.495,0H231.3v-.95h2.247Zm-4.495,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Z",
    transform: "translate(-207.75 -328.501)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 1.141,
    height: 0.95,
    transform: "translate(2.186 1.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M318.956,229.653h-2.247v-.95h2.247Zm-4.495,0h-2.248v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.247Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95H283Zm-4.495,0h-2.248v-.95H278.5Zm-4.5,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.248Zm-4.5,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.5,0H235.8v-.95h2.247Zm-4.495,0H231.3v-.95h2.247Zm-4.495,0h-2.247v-.95h2.247Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Zm-4.495,0h-2.247v-.95h2.248Z",
    transform: "translate(-207.75 -226.897)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.339,
    height: 34.216,
    transform: "translate(17.203 54.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.339,
    height: 58.356,
    transform: "translate(48.782 30.279)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.339,
    height: 86.544,
    transform: "translate(78.361 2.091)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2.281,
    cy: 2.281,
    r: 2.281,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2.281,
    cy: 2.281,
    r: 2.281,
    transform: "translate(0 25.362)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2.281,
    cy: 2.281,
    r: 2.281,
    transform: "translate(0 50.724)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaImg);
export default __webpack_public_path__ + "static/media/q&a_img.5e52f28aeddac4bba68edc320476fc26.svg";
export { ForwardRef as ReactComponent };